<template>
  <div class="horn-wrap" ref="horn">
    <div class="wrapper" :class="'horn-' + way" @mouseover="onMouseOver" @mouseout="onMouseOut" ref="wrapper">
      <div class="list" ref="list">
        <slot>
          <horn-item class="horn" v-for="(item, index) in data" :key="index + 'item'">
            <p @click="handle_click()" class="content">
              {{item.content}}
            </p>
            <!--<span class="time">{{item.date}}</span>-->
          </horn-item>
        </slot>
      </div>
      <div class="list copy-wrap" :style="margin" ref="copy"></div>
    </div>
    <Dialog
      title="公告"
      :visible.sync="isVisible"
      width="80%"
      >
      <Table
        :data="data"
        style="width: 100%"
         @row-click="rowClick"
      >
        <!--<TableColumn
          label="日期"
          width="180">
          <template slot-scope="scope">
            <span>{{ scope.row.send_time|formatDate }}</span>
          </template>
        </TableColumn>
        <TableColumn
          prop="title"
          label="标题"
          width="180">
        </TableColumn>-->
        <TableColumn
          prop="content"
          label="详情">
        </TableColumn>
      </Table>
      <span slot="footer" class="dialog-footer">
    <Button type="primary" @click="isVisible= false">关闭</Button>
  </span>
    </Dialog >
  </div>
</template>

<script>
  import HornItem from './horn-item';
  import {prefixStyle} from './utils';
  import  {Dialog,Table,TableColumn,Button} from  "element-ui";

  export default {
    name: "index",
    components: {
      HornItem,
      Dialog,
      Table,
      TableColumn,
      Button
    },
    filters: {
      formatDate: function (value) {
        let date = new Date(parseInt(value+"000"));
        let y = date.getFullYear();
        let MM = date.getMonth() + 1;
        MM = MM < 10 ? ('0' + MM) : MM;
        let d = date.getDate();
        d = d < 10 ? ('0' + d) : d;
        let h = date.getHours();
        h = h < 10 ? ('0' + h) : h;
        let m = date.getMinutes();
        m = m < 10 ? ('0' + m) : m;
        let s = date.getSeconds();
        s = s < 10 ? ('0' + s) : s;
        return y + '-' + MM + '-' + d + ' ' + h + ':' + m + ':' + s;
      }
    },
    props: {
      data: {
        type: Array,
        default() {
          return []
        }
      },
      direction: {
        type: String,
        default: 'left' // left right -> horizontal  |  up down -> vertical
      },
      copyOffset: {
        type: Number,
        default: 20
      }
    },
    data(){
      return {
        isVisible:false,
      }
    },
    watch: {
      data: {
        deep: true,
        handler() {
          this.$nextTick(() => {
            this.startP = 0;
            this.stop();
            this.init();
          });
        }
      }
    },
    computed: {
      way() {
        let _way = 'horizontal';
        switch (this.direction) {
          case 'up':
          case 'down':
            _way = 'vertical';
            break;
          case 'left':
          case 'right':
            _way = 'horizontal';
            break;
        }
        return _way;
      },

      // ++ 的方向
      normalWay() {
        return this.direction === 'left' || this.direction === 'up';
      },
      margin() {
        let name = 'marginLeft';

        switch (this.direction) {
          case 'up':
          case 'down':
            name = 'marginTop';
            break;
          case 'left':
          case 'right':
            name = 'marginLeft';
            break;
        }

        const dis = Number(this.copyOffset).toString() === 'NaN' ? this.copyOffset : this.copyOffset + 'px';
        return {
          [name]: dis
        }
      },
    },
    mounted() {
      this.horn = this.$refs.horn;
      this.copy = this.$refs.copy;
      this.list = this.$refs.list;
      this.wrapper = this.$refs.wrapper;
      this.children = this.list.children;

      // 初始化位置
      this.startP = 0;
      this.init();

    },
    methods: {
      // 打开弹窗
      handle_click(item) {
        this.isVisible=true;

      },
      /**
       * 获取临界值
       */
      limitOffset() {
        const offset = this.way === 'horizontal' ? 'Width' : 'Height';

        const wrapperWidth = this.wrapper['offset' + offset];

        // const normal = this.normalWay ? parseInt((wrapperWidth - this.copyOffset) / 2) : wrapperWidth -
      },
      init() {
        this.initialCopyList();
        this.initialStartPosition();
        this.animate();
      },

      // 初始化克隆的列表
      initialCopyList() {
        if (!this.children.length) return false;
        this.copy.innerHTML = null;
        for (let i = 0; i < this.children.length; i++) {
          const _clone = this.children[i].cloneNode(true);
          _clone.onclick = () => this.handle_click(this.data[i]);
          this.copy.appendChild(_clone);
        }
      },

      // 初始化初始偏移的位置
      initialStartPosition() {

        const direction = {up: 'Top', down: 'Top', left: 'Left', right: 'Left'};
        const offset = this.way === 'horizontal' ? 'Width' : 'Height';
        const _dir = direction[this.direction];

        // 单个list的宽度或高度
        const firstListBound = this.list['offset' + offset];
        const containerBound = this.horn['offset' + offset];
        const copyOffsetDir = this.copy['offset' + _dir];


        // normalWay  up & left

        this.startP = this.first = this.normalWay ? 0 : -(copyOffsetDir + firstListBound - containerBound);

        this.max = -(this.normalWay ? firstListBound + this.copyOffset : firstListBound - containerBound);

      },
      animate() {

        const step = () => {

          if (this.normalWay) {
            this.startP -= 1;
            if (this.startP <= this.max) {
              this.startP = this.first;
            }
          } else {
            this.startP += 1;
            if (this.startP >= this.max) {
              this.startP = this.first;
            }
          }

          // 计算下一步的位置
          let x, y;
          if (this.way === 'horizontal') {
            x = this.startP;
            y = 0;
          } else {
            y = this.startP;
            x = 0;
          }

          this.wrapper.style[prefixStyle('transform')] = `translate3d(${x}px, ${y}px, 0px)`;
          this._timer = requestAnimationFrame(step);
        };
        this._timer = requestAnimationFrame(step);
      },
      stop() {
        cancelAnimationFrame(this._timer);
      },

      onMouseOver() {
        this.stop();
      },
      onMouseOut() {
        this.animate();
      },
      rowClick(item){
        this.$emit('click', item);
        this.isVisible=false;
      }
    }
  }
</script>

<style scoped lang="stylus">
  .horn-wrap {
    height 100%
    overflow hidden

    .wrapper {
      height 100%
      position relative

      .content {
        cursor pointer
        display inline-block
        overflow hidden
        white-space nowrap
        text-overflow ellipsis
        vertical-align middle
      }

      .time {
        color #999999
        margin-left 10px
        vertical-align middle
      }

      &.horn-horizontal {
        display inline-block
        white-space nowrap

        .list {
          height 100%
          display inline-block
        }

        .copy-wrap {
          white-space nowrap
          vertical-align middle
        }

        .horn {
          &:before {
            width 4px
            height 4px
            content ""
            display inline-block
            margin-right 10px
            border-radius 2px
            vertical-align middle
            background-color #999999
          }
        }

        .horn + .horn {
          margin-left 20px
        }
      }

      &.horn-vertical {
        display block
        height auto

        .horn {
          height 36px
          display block
        }
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/c-laba/mini-horn/index.vue